// extracted by mini-css-extract-plugin
module.exports = {"bookMidBtn":"BookMidBtn_bookMidBtn__2fEJJ","bookMidBtn_mobFull":"BookMidBtn_bookMidBtn_mobFull__u2ZI_","bookMidBtn_small":"BookMidBtn_bookMidBtn_small__oJ2wK"};